import React from "react";
import IBPlanningSummaryGrid from "./ibplanningSummaryGrid";
import IBPlanningSummaryFilters from "./ibplanningSummaryFilters";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { getDataWithQueryString } from "../../../../api/componentAPIs";

const styles = {
  subModule: {
    height: "100%",
    display: "flex",
    boxSizing: "border-box"
  },
  subModuleLeft: {
    width: "70%"
  },
  subModuleRight: {
    width: "30%",
    overflowY: "auto",
    overflowX: "hidden"
  }
};
class IBPlanningSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      publishedTerminals: [],
      filteredPublishedTerminals: null
    };
  }

  componentDidMount() {
    this._isComponentMounted = true;
    this.getPublishedTerminals();
  }

  componentWillUnmount() {
    this._isComponentMounted = false;
  }

  getPublishedTerminals = date => {
    const queryParameter = date ? `planDate=${date}` : "";

    getDataWithQueryString("GetPublishedTerminals", queryParameter).then(
      response => {
        if (this._isComponentMounted) {
          if (response.status === 200) {
            this.setState({
              publishedTerminals: response.data,
              filteredPublishedTerminals: response.data
            });
          } else {
            this.setState({
              publishedTerminals: [],
              filteredPublishedTerminals: []
            });
          }
        }
      },
      error => {
        if (this._isComponentMounted) {
          this.setState({
            publishedTerminals: [],
            filteredPublishedTerminals: []
          });
        }
      }
    );
  };

  updatePublishedTerminals = list => {
    this.setState({
      filteredPublishedTerminals: list
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.subModule}>
        <div className={classes.subModuleLeft}>
          <IBPlanningSummaryGrid data={this.state.filteredPublishedTerminals} />
        </div>
        <div className={`${classes.subModuleRight} customScroll`}>
          <IBPlanningSummaryFilters
            data={this.state.publishedTerminals}
            updatePublishedTerminals={this.updatePublishedTerminals}
            getPublishedTerminals={this.getPublishedTerminals}
          />
        </div>
      </div>
    );
  }
}
export default compose(
  withStyles(styles),
  withUserProfile
)(IBPlanningSummary);
